<template>
    <v-dialog max-width="450" persistent v-model="showDialog" transition="dialog-bottom-transition">
        <v-card>
            <v-card-title>
                <v-layout row wrap>
                    <v-flex xs12 class="mt-3">
                        <h3 class="headline grey--text text--darken-2 text-xs-center">Add Additional Loads</h3>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-combobox
                          label="Load Numbers"
                          v-model="load"
                          prepend-icon="local_shipping"
                          ref="loadSelect"
                          chips
                          multiple
                          clearable
                          deletable-chips
                          color="primary"
                        >
                        </v-combobox>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-layout row wrap>
                    <v-flex xs12 class="mt-3">
                        <v-layout row wrap>
                            <v-spacer></v-spacer>
                            <v-btn class="success" @click="addLoads" :disabled="load.length === 0" :loading="saving">Add Loads</v-btn>
                            <v-btn class="grey darken-1 white--text" @click="close" :disabled="saving">Cancel</v-btn>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import axios from 'axios'
  export default {
    props: ['showDialog', 'taId'],
    data () {
      return {
        url: this.$store.getters.url,
        load: [],
        saving: false
      }
    },
    computed: {
      company () {
        return this.$store.getters.company
      }
    },
    watch: {
      showDialog: function (val) {
        this.$store.dispatch('checkLoginTime')
      }
    },
    methods: {
      close () {
        this.$emit('closeLoadDialog')
      },
      addLoads () {
        this.saving = true
        axios.post(this.url + `/tanda-service/addLoadsToShift.ajax.php`, {load_ids: this.load, ta_id: this.taId, company: this.company})
          .then(result => {
            this.saving = false
            this.$emit('closeLoadDialog')
            this.load = []
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/AddLoadDialog.vue